import React from 'react'

import Base from '../_Base'

const BrazilAl = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <g clipPath="url(#brazil_al)">
      <rect width="24" height="24" rx="2" fill="#00A651" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.414 6.915c1.01-.014 1.57 0 2.58-.007.029 2.735.007 5.041.007 7.776 1.629.007 3.604-.014 5.232.007.023.653.008 1.741.008 2.394-2.646.007-5.181 0-7.827 0 0-3.38-.007-6.775 0-10.17ZM7.447 13.439h-.509l.509-4.184.508 4.184h-.508Zm2.174-6.53H5.272L3.754 17.091h3.044l.17-1.864h.958l.17 1.864h3.043L9.62 6.908Z"
        fill="#fff"
      />
    </g>
    <rect x=".5" y=".5" width="23" height="23" rx="1.5" stroke="#fff" />
    <defs>
      <clipPath id="brazil_al">
        <rect width="24" height="24" rx="2" fill="#fff" />
      </clipPath>
    </defs>
  </Base>
)

export default BrazilAl
